import * as config from './config'


export const getConfigurationSuccessfully = (response, self) => {
    if (response === "" || response === undefined) {
        location.href = config.rootURL + "Error/Index";
    }
    var result = response;

    self.menu = result.Menus;
    self.contact = result.Contact;
    self.mainTitle = result.MainTitle;

    self.login = true;
    self.ready = true;
}
export const getConfigurationFailedly = (err, self) => {
    console.log(err);
    self.login = false;
    location.href = config.rootURL + "/Error/Index";
}

export const styleObject = {
    background: "black",

    "margin-top": "-80px",

    "margin-right": "-30px",

    "margin-bottom": "10px",

    "margin-left": "27px",

    position: "absolute",

    "z-index": "9999",

    "font-size": "12px"
};

export const contactStyle = {
    "border-radius": 0,

    "margin-top": "16px",

    "margin-bottom": "45px",

    width: "100%",

    background: "#1cc"
};

export const getInActiveClass = (active) => {
    if (!active) {
        return "unallow";
    }
    return "allow";
}
export const goToContact = (contactURL) => {
    window.open(contactURL, '_blank');
}

export const getURL4Image = (image) => config.rootURL + "/Content/images/" + image;


export const mouseOver = (index, menu) => {
    menu[index].Show = true;

    for (var i = 0; i < menu.length; i++) {
        if (i !== index) {
            menu[i].Show = false;
        }
    }
};

export const mouseLeave = function (menu) {
    for (var i = 0; i < menu.length; i++) {
        menu[i].Show = false;
    }
};

export const mouseLeaveTooltip = function (menu) {
    mouseLeave(menu);
};

export const mouseOverTooltip = function (index, menu) {
    mouseOver(index, menu);
};


export const defaultViewClick = function (index, menu) {
    menu[index].DefaultView = !menu[index].DefaultView;
};

export const buildBoostrapClass = (param) => {
    var index = param.index;
    var menu = param.menu;
    if (menu.length % 3 == 1) {
        if (index == menu.length - 1) {
            return "col-md-offset-3 col-md-3 smi-block";
        }
    }

    if (menu.length % 3 == 2) {
        if (index == menu.length - 2) {
            return "col-md-offset-2 col-md-3 smi-block";
        }
    }

    return "col-md-4 smi-block";
};